export const rippleStyles: Partial<CSSStyleDeclaration> = {
  position: 'absolute',
  borderRadius: '50%',
  pointerEvents: 'none',
  transform: 'scale3d(0, 0, 0)',
  transition: 'opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1)',
  backgroundColor: 'rgba(252,252,252,0.5)',
};
